import React, {useEffect, useState} from 'react'
import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import Headline from '#components/a/Headline'
import StatusSelect from '#components/m/StatusSelect'
import Text from '#components/a/Text'
import {useParams} from 'react-router-dom'

export const PraxisaufgabenDetail = () => {
  const params = useParams()
  const [user, setUser] = useState(undefined)

  const loadUser = async () => {
    try {
      const userinfo = await Api.getUserById(params.azubiId)
      setUser(userinfo)
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  useEffect(() => {
    loadUser()
  }, [params.azubiId])

  return (
    <div className="praxisaufgabenDetail">
      <Headline importance={1} modifier="section" text={i18n.t('status_overview_title')} />
      {user && (
        <div>
          <Text text={`${user.lastname}, ${user.firstname}`} />
          <div className="praxisaufgabenSelectContainer">
            <StatusSelect displayUserInfo={false} user={user} key={user.id} />
          </div>
        </div>
      )}
    </div>
  )
}

export default PraxisaufgabenDetail
